import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  colors: ['#FFF'],
  bold: false,
  italic: false,
  supportPositions: [],
  position: '',
  mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_OVERLAY_POSITION: {
      return {
        ...state,
        position: action.position,
        supportPositions: action.supportPositions,
      }
    }
    case FJActionConstant.SET_OVERLAY_COLORS: {
      return {
        ...state,
        colors: action.colors,
      }
    }
    case FJActionConstant.SET_OVERLAY_TEXT_BOLD: {
      return {
        ...state,
        bold: action.bold,
      }
    }
    case FJActionConstant.SET_OVERLAY_TEXT_ITALIC: {
      return {
        ...state,
        italic: action.italic,
      }
    }
    case FJActionConstant.SET_OVERLAY_MEDIA_STATUS: {
      return {
        ...state,
        mediaStatus: action.mediaStatus,
      }
    }
    default:
      return state;
  }
}